var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingOkayActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "url(#paint0_linear_2044_1174)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3985 35.2511H13.6014C13.2036 35.2511 12.822 35.0931 12.5407 34.8118C12.2594 34.5305 12.1014 34.1489 12.1014 33.7511C12.1014 33.3533 12.2594 32.9717 12.5407 32.6904C12.822 32.4091 13.2036 32.2511 13.6014 32.2511H34.3985C34.7963 32.2511 35.1778 32.4091 35.4592 32.6904C35.7405 32.9717 35.8985 33.3533 35.8985 33.7511C35.8985 34.1489 35.7405 34.5305 35.4592 34.8118C35.1778 35.0931 34.7963 35.2511 34.3985 35.2511Z",
    fill: "#2C4866"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4717 18.7507H29.2217C28.8239 18.7507 28.4424 18.9087 28.1611 19.19C27.8798 19.4713 27.7217 19.8528 27.7217 20.2507C27.7217 20.6485 27.8798 21.03 28.1611 21.3113C28.4424 21.5926 28.8239 21.7507 29.2217 21.7507H30.3467C30.3467 22.5463 30.6628 23.3094 31.2254 23.872C31.788 24.4346 32.5511 24.7507 33.3467 24.7507C34.1424 24.7507 34.9055 24.4346 35.4681 23.872C36.0307 23.3094 36.3467 22.5463 36.3467 21.7507H37.4717C37.8696 21.7507 38.2511 21.5926 38.5324 21.3113C38.8137 21.03 38.9717 20.6485 38.9717 20.2507C38.9717 19.8528 38.8137 19.4713 38.5324 19.19C38.2511 18.9087 37.8696 18.7507 37.4717 18.7507Z",
    fill: "url(#paint1_linear_2044_1174)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7217 18.7507H10.4717C10.0739 18.7507 9.69239 18.9087 9.41108 19.19C9.12978 19.4713 8.97174 19.8528 8.97174 20.2507C8.97174 20.6485 9.12978 21.03 9.41108 21.3113C9.69239 21.5926 10.0739 21.7507 10.4717 21.7507H11.5967C11.5967 22.5463 11.9128 23.3094 12.4754 23.872C13.038 24.4346 13.8011 24.7507 14.5967 24.7507C15.3924 24.7507 16.1555 24.4346 16.7181 23.872C17.2807 23.3094 17.5967 22.5463 17.5967 21.7507H18.7217C19.1196 21.7507 19.5011 21.5926 19.7824 21.3113C20.0637 21.03 20.2217 20.6485 20.2217 20.2507C20.2217 19.8528 20.0637 19.4713 19.7824 19.19C19.5011 18.9087 19.1196 18.7507 18.7217 18.7507Z",
    fill: "url(#paint2_linear_2044_1174)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2044_1174",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0702,
    stopColor: "#FFCD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2689,
    stopColor: "#FFC037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4806,
    stopColor: "#FFB726"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7119,
    stopColor: "#FFB21C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB019"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2044_1174",
    x1: 33.3467,
    y1: 18.7507,
    x2: 33.3467,
    y2: 24.7507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#334E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#142F47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2044_1174",
    x1: 14.5967,
    y1: 18.7507,
    x2: 14.5967,
    y2: 24.7507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#334E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#142F47"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingOkayActive);
export default __webpack_public_path__ + "static/media/rating_okay_active.fbb45a047cff88c5d70b9c72fb8113a4.svg";
export { ForwardRef as ReactComponent };